import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Canonical domain enforcement: send www.aiturfdesigner.com -> https://aiturfdesigner.com (single canonical host).
// Strictly scoped to that one hostname so Prime Gym Turf and the preview/emergent hosts are never affected.
if (typeof window !== "undefined" && window.location.hostname === "www.aiturfdesigner.com") {
  window.location.replace("https://aiturfdesigner.com" + window.location.pathname + window.location.search + window.location.hash);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
